import React, { useEffect } from 'react';
import { MY_DASHBOARD_TEMPLATES } from './myDashboardTemplates';
import TemplatePreview, { templateWidgetSummary } from './TemplatePreview';
import './TemplateGallery.css';

/** Starter dashboards from your own accounts, each with a live preview of its layout, plus "Start blank". */
export function TemplateGallery({ onPick, includeBlank = true }) {
  return (
    <div className="tpl-gallery">
      {MY_DASHBOARD_TEMPLATES.map((t, i) => (
        <button type="button" key={t.id} className={`tpl-card${t.featured ? ' is-featured' : ''}`} style={{ '--i': i }} onClick={() => onPick(t.id)}>
          {t.featured ? <span className="tpl-badge">Recommended</span> : null}
          <span className="tpl-frame">
            <span className="tpl-frame-bar" aria-hidden="true"><i /><i /><i /></span>
            <TemplatePreview templateId={t.id} />
          </span>
          <span className="tpl-card-text">
            <strong>{t.name}</strong>
            <span>{t.description}</span>
            <span className="tpl-chips">
              {templateWidgetSummary(t).map((c) => <span key={c} className="tpl-chip">{c}</span>)}
            </span>
          </span>
          <span className="tpl-cta">Use this layout <span aria-hidden="true">→</span></span>
        </button>
      ))}
      {includeBlank ? (
        <button type="button" className="tpl-card tpl-card-blank" style={{ '--i': MY_DASHBOARD_TEMPLATES.length }} onClick={() => onPick(null)}>
          <span className="tpl-frame">
            <span className="tpl-frame-bar" aria-hidden="true"><i /><i /><i /></span>
            <TemplatePreview templateId={null} />
          </span>
          <span className="tpl-card-text">
            <strong>Start blank</strong>
            <span>Pick every widget yourself: your accounts, market data, company strategies, or a mix.</span>
          </span>
          <span className="tpl-cta">Start from scratch <span aria-hidden="true">→</span></span>
        </button>
      ) : null}
    </div>
  );
}

/** "New dashboard" picker. */
export function TemplatePickerModal({ open, onPick, onClose }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="tpl-modal-root" role="dialog" aria-modal="true" aria-label="New dashboard">
      <button type="button" className="tpl-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="tpl-modal">
        <div className="tpl-modal-head">
          <h3>New dashboard</h3>
          <button type="button" className="tpl-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <p className="tpl-sub">Start from a layout built from your own accounts, or start blank.</p>
        <TemplateGallery onPick={onPick} />
      </div>
    </div>
  );
}

export default TemplateGallery;
